import React, { useState, useEffect, useContext } from "react";
import { ehCanalRestrito } from "../../helpers/canalConexao";
import { useParams, useHistory } from "react-router-dom";

import { toast } from "react-toastify";
import openSocket from "socket.io-client";
import Timer from "./Timer";
import clsx from "clsx";

import {
  Paper, makeStyles, Button, Switch, FormGroup, FormControlLabel, Grid, Box, Typography
} from "@material-ui/core";

import ContactDrawer from "../ContactDrawer";
import PainelBuscaConversa from "../PainelBuscaConversa";
import MessageInput from "../MessageInput/";
import TicketHeader from "../TicketHeader";
import TicketInfo from "../TicketInfo";
import TicketActionButtons from "../TicketActionButtons";
import MessagesList from "../MessagesList";
import BlacklistedView from "../BlacklistedView";
import InputBloqueado from "../InputBloqueado";
import api from "../../services/api";
import { ReplyMessageProvider } from "../../context/ReplyingMessage/ReplyingMessageContext";
import { AuthContext } from "../../context/Auth/AuthContext";
import { registrarConsumidorEsc } from "../../helpers/escConversa";
import { podeAlternarIa } from "../../helpers/botaoIa";
import { fontWeight } from "@mui/system";
import ModalEstoqueOutrasLojas from "../ModalEstoqueOutrasLojas";
import { i18n } from "../../translate/i18n";

const http = require('http');

const init = {
  host: 'localhost',
  path: '/zdgDialogFlowOn',
  port: 8080,
  method: 'POST',
  headers: {
    'content-type': 'application/json; charset=utf-8'
  }
};

const init2 = {
  host: 'localhost',
  path: '/zdgDialogFlowOff',
  port: 8080,
  method: 'POST',
  headers: {
    'content-type': 'application/json; charset=utf-8'
  }
};

const init3 = {
  host: 'localhost',
  path: '/zdgChatBotOn',
  port: 8080,
  method: 'POST',
  headers: {
    'content-type': 'application/json; charset=utf-8'
  }
};

const init4 = {
  host: 'localhost',
  path: '/zdgChatBotOff',
  port: 8080,
  method: 'POST',
  headers: {
    'content-type': 'application/json; charset=utf-8'
  }
};

const init5 = {
  host: 'localhost',
  path: '/zdgDialogFlowOnAudio',
  port: 8080,
  method: 'POST',
  headers: {
    'content-type': 'application/json; charset=utf-8'
  }
};

const init6 = {
  host: 'localhost',
  path: '/zdgDialogFlowOffAudio',
  port: 8080,
  method: 'POST',
  headers: {
    'content-type': 'application/json; charset=utf-8'
  }
};

const callback = function (response) {
  let result = Buffer.alloc(0);
  response.on('data', function (chunk) {
    result = Buffer.concat([result, chunk]);
  });

  response.on('end', function () {
    console.log(result.toString());
  });
};

const drawerWidth = 320;

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    display: "flex",
    height: "100%",
    position: "relative",
    overflow: "hidden",
  },

  // Mesma casca do "Selecione uma conversa" da pages/Tickets: ocupa a coluna da
  // direita inteira, com o fundo base do tema (funciona no light e no dark).
  conversaIndisponivel: {
    backgroundColor: "var(--bg-base)",
    color: "var(--text-muted)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    textAlign: "center",
    borderRadius: 0,
    padding: theme.spacing(2),
  },

  conversaIndisponivelDetalhe: {
    marginTop: theme.spacing(0.5),
  },

  conversaIndisponivelAcao: {
    marginTop: theme.spacing(2),
  },

  ticketInfo: {
    flex: "1 1 260px",
    minWidth: 0,
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    textAlign: "left",
    "& .MuiCardHeader-root": {
      padding: theme.spacing(1),
    },
    // minWidth:0 no content é o que permite o título/subtítulo truncarem
    // (noWrap) em vez de "vazar" e sobrepor os tempos/ações quando o espaço
    // aperta (zoom, monitor pequeno ou barra lateral de contato aberta).
    "& .MuiCardHeader-content": {
      minWidth: 0,
    },
  },

  ticketStats: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(3),
    flex: "none",
    position: "relative",
    paddingLeft: theme.spacing(2.5),
    paddingRight: theme.spacing(2.5),
    // Divisores verticais suaves: hairline de 1px com gradiente que esvanece nas
    // pontas, separando os tempos das infos do contato (esquerda) e dos botões
    // (direita). Gradiente em vez de borda cheia pra não virar "moldura".
    "&::before, &::after": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 1,
      height: 26,
      backgroundImage: `linear-gradient(to bottom, transparent, ${theme.palette.text.secondary}, transparent)`,
      opacity: 0.5,
    },
    "&::before": { left: 0 },
    "&::after": { right: 0 },
    // Em telas medianas pra baixo, os tempos descem para uma linha própria
    // em vez de disputar espaço (e sobrepor) com o nome do contato.
    [theme.breakpoints.down("md")]: {
      order: 3,
      flexBasis: "100%",
      gap: theme.spacing(2),
      paddingLeft: theme.spacing(1),
      paddingRight: 0,
      paddingBottom: theme.spacing(0.5),
      // Ocupando a linha inteira, divisor nas laterais não faz sentido.
      "&::before, &::after": {
        display: "none",
      },
    },
  },

  statItem: {
    display: "flex",
    flexDirection: "column",
    lineHeight: 1.3,
  },

  statLabel: {
    fontSize: 10,
    fontWeight: 600,
    letterSpacing: "0.5px",
    textTransform: "uppercase",
    color: theme.palette.text.secondary,
    whiteSpace: "nowrap",
  },

  statValue: {
    fontSize: 14,
    fontWeight: 700,
    color: theme.palette.text.primary,
    fontVariantNumeric: "tabular-nums",
  },

  divButtonLead: {
    backgroundColor: theme.palette.background.default,
    maxWidth: "20%",
    flexBasis: "20%",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "20%",
      flexBasis: "20%",
    },
    display: "inline-block",
    textAlign: "center",
    paddingTop: "20px",
  },

  buttonLead: {
    display: "inline-block",
    textAlign: "center",
    backgroundColor: "#4CAF50",
    border: "none",
    color: "white",
    textDecoration: "none",
    fontSize: "12px",
    borderRadius: "4px",
    height: "30px",
    width: "100px",
    cursor: "pointer",
    '&:hover': {
      backgroundColor: "#3F9042",
    },
  },

  // Terceira "célula" do cabeçalho (depois do divisor dos tempos): largura só do
  // que os botões precisam, encostada na direita. O padding lateral igual dos
  // dois lados é o que dá a sensação de centralizado (o desalinhamento antigo
  // vinha de um item flex vazio dentro de TicketActionButtons).
  ticketActionButtons: {
    flex: "none",
    marginLeft: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(0.5),
  },

  mainWrapper: {
    flex: 1,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderLeft: "0",
    marginRight: -drawerWidth,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },

  mainWrapperShift: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: 0,
  },
  button: {
    position: "relative",
    backgroundColor: "green",
    fontSize: "10px",
    margin: "35px",
    marginLeft: "2px",
    marginRight: "2px",
    color: "#FFF",
    width: "5%",
    '&:hover': {
      backgroundColor: "red",
      color: "#FFF"
    }, [theme.breakpoints.down("sm")]: {
      maxWidth: "100%",
      flexBasis: "100%",
      margin: "5px",
      marginLeft: "50px",
      marginRight: "50px",
      marginBottom: "5px",
    },
  },
  box: {
    backgroundColor: theme.palette.background.default,
    position: "relative",
    marginLeft: "2px",
    marginRight: "2px",
    [theme.breakpoints.down("sm")]: {
      display: "none"
    },
  },
}));

// Mesma comparação de helpers/AcessoTicket no backend: número contra número,
// e null nunca casa com null. O `===` cru divergia dos dois lados — "1" !== 1 barrava
// quem podia, e null === null liberava a barra pra quem o backend recusa com 400.
const mesmoNumero = (a, b) => a != null && b != null && Number(a) === Number(b);

const Ticket = () => {

  const [checked, setChecked] = React.useState(false);
  const [checked2, setChecked2] = React.useState(false);
  const [checked3, setChecked3] = React.useState(false);

  const { ticketId } = useParams();
  const history = useHistory();
  const classes = useStyles();

  const [drawerOpen, setDrawerOpen] = useState(false);
  // A lateral direita mostra os dados do contato ou a busca; `n` faz o clique no mesmo resultado valer de novo.
  const [painelBusca, setPainelBusca] = useState(false);
  const [irParaMensagem, setIrParaMensagem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [contact, setContact] = useState({});
  const [ticket, setTicket] = useState({});
  const [urlBackend, setUrlBackend] = useState();
  // Do GET /tickets/:id, fora do `ticket`: o socket troca o ticket inteiro e isto é de quem olha.
  const [acessoConexao, setAcessoConexao] = useState(false);
  const [isBlacklisted, setIsBlacklisted] = useState(false);
  const [estoqueOutrasLojas, setEstoqueOutrasLojas] = useState([]);
  const [modalEstoqueOutrasLojasOpen, setModalEstoqueOutrasLojasOpen] = useState(false);
  // null | "naoEncontrada" (404: não existe, ou é de conexão que o usuário não
  // acessa — o backend responde igual nos dois casos de propósito) | "erro".
  const [falhaAoCarregar, setFalhaAoCarregar] = useState(null);
  const [tentativaCarregar, setTentativaCarregar] = useState(0);

  const { user } = useContext(AuthContext);
  // Backend da conexão do ticket quando não é um dos do usuário (conversa aberta pelo acesso por
  // filial); com o vínculo fica null, e trocar de conversa não reabre os sockets.
  const urlBackendForaDoUsuario =
    urlBackend && urlBackend !== process.env.REACT_APP_BACKEND_URL
      && !(user?.whatsapps || []).some(w => w.urlBackend === urlBackend)
      ? urlBackend : null;

  async function DialogFlowOn() {
    const req = http.request(init, callback);
    const body = `{"msgFrom":"${contact.number}"}`;
    await req.write(body);
    alert(`DialogFlow ON: ${contact.name} - WPP: ${contact.number} Ticket: #${ticket.id}`);
    req.end();
  }

  async function DialogFlowOff() {
    const req = http.request(init2, callback);
    const body = `{"msgFrom":"${contact.number}"}`;
    await req.write(body);
    alert(`DialogFlow Off: ${contact.name} - WPP: ${contact.number} Ticket: #${ticket.id}`);
    req.end();
  }

  async function DialogFlowOnAudio() {
    const req = http.request(init5, callback);
    const body = `{"msgFrom":"${contact.number}"}`;
    await req.write(body);
    alert(`DialogFlow AUDIO ON: ${contact.name} - WPP: ${contact.number} Ticket: #${ticket.id}`);
    req.end();
  }

  async function DialogFlowOffAudio() {
    const req = http.request(init6, callback);
    const body = `{"msgFrom":"${contact.number}"}`;
    await req.write(body);
    alert(`DialogFlow AUDIO Off: ${contact.name} - WPP: ${contact.number} Ticket: #${ticket.id}`);
    req.end();
  }

  async function ChatBotOn() {
    const req = http.request(init3, callback);
    const body = `{"msgFrom":"${contact.number}"}`;
    await req.write(body);
    alert(`MYSQL On: ${contact.name} - WPP: ${contact.number} Ticket: #${ticket.id}`);
    req.end();
  }

  async function ChatBotOff() {
    const req = http.request(init4, callback);
    const body = `{"msgFrom":"${contact.number}"}`;
    await req.write(body);
    alert(`MYSQL Off: ${contact.name} - WPP: ${contact.number} Ticket: #${ticket.id}`);
    req.end();
  }

  useEffect(() => {
    setLoading(true);
    setIsBlacklisted(false);
    setFalhaAoCarregar(null);
    setAcessoConexao(false);
    const delayDebounceFn = setTimeout(() => {
      const fetchTicket = async () => {
        try {
          const { data } = await api.get("/tickets/" + ticketId);

          setContact(data.contact);
          setUrlBackend(data.whatsapp.urlBackend);
          setAcessoConexao(!!data.acessoConexao);
          setTicket(data);
          setLoading(false);
        } catch (err) {
          // A falha é marcada ANTES do setLoading: sem isso, o `loading` caindo
          // rendereza a casca com `ticket` ainda {} — e era aí que a tela ficava
          // branca, porque TicketActionButtons lia `ticket.contact.name` e a
          // exceção de render derrubava a árvore INTEIRA (o React desmonta tudo).
          // Só não tinha crash no caminho feliz porque lá o setTicket vem antes.
          // Quem tem tela própria não leva toast — mesma regra das telas de acesso
          // negado (ver errors/toastError.js).
          const naoEncontrada = err?.response?.status === 404;
          setFalhaAoCarregar(naoEncontrada ? "naoEncontrada" : "erro");
          setLoading(false);
          if (!naoEncontrada) console.error("Falha ao carregar o ticket:", err);
        }
      };
      fetchTicket();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [ticketId, history, tentativaCarregar]);

  useEffect(() => {
    if (!contact?.id || ticket?.isGroup) {
      setIsBlacklisted(false);
      return undefined;
    }
    let canceled = false;
    (async () => {
      try {
        const { data } = await api.get(`/blacklist/check/${contact.id}`, {
          params: { connection: ticket?.whatsappId != null ? ticket.whatsappId : "" }
        });
        if (!canceled) setIsBlacklisted(!!(data && data.blocked));
      } catch (err) {
        if (!canceled) setIsBlacklisted(false);
      }
    })();
    return () => { canceled = true; };
  }, [contact?.id, ticket?.whatsappId, ticket?.isGroup]);

  useEffect(() => {
    if (!contact?.id) return undefined;
    let urlsUnicas = [];
    if (user && JSON.stringify(user) !== '{}') {
      urlsUnicas = new Set([process.env.REACT_APP_BACKEND_URL]);
      (user.whatsapps || [])
        .map(w => w.urlBackend)
        .filter(Boolean)
        .forEach(url => urlsUnicas.add(url));
      urlsUnicas = [...urlsUnicas];
    }
    const sockets = [];
    urlsUnicas.forEach(url => {
      const socket = openSocket(url.trim() + "/");
      sockets.push(socket);
      socket.on("blacklist", (data) => {
        if (!data) return;
        if (Number(data.contactId) !== Number(contact.id)) return;
        const sameConn = data.connection == null
          || ticket?.whatsappId == null
          || Number(data.connection) === Number(ticket.whatsappId);
        if (!sameConn) return;
        if (data.action === "block") setIsBlacklisted(true);
        if (data.action === "unblock") setIsBlacklisted(false);
      });
    });
    return () => sockets.forEach(s => s.disconnect());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contact?.id, ticket?.whatsappId]);

  useEffect(() => {
    let urlsUnicas = [];
    if (user && JSON.stringify(user) !== '{}') {
      urlsUnicas = new Set([process.env.REACT_APP_BACKEND_URL]);
      [...(user.whatsapps || []).map(w => w.urlBackend), urlBackendForaDoUsuario]
        .filter(Boolean)
        .forEach(url => urlsUnicas.add(url));
      urlsUnicas = [...urlsUnicas];
    } else {
      console.error("USUARIO NÃO ENCONTRADO NO SOCKET");
    }
    const sockets = [];
    urlsUnicas.forEach(url => {
      const socket = openSocket(url.trim() + "/");
      sockets.push(socket);

      socket.on("connect", () => socket.emit("joinChatBox", ticketId));

      socket.on("ticket", (data) => {
        if (data.action === "update") {
          setTicket(data.ticket);
        }

        if (data.action === "delete") {
          // Em /chat, manter o usuário na mesma conversa: o evento "blacklist"
          // tratará a troca de view (BlacklistedView). Em /tickets, mantém o
          // comportamento legado de redirecionar para a lista.
          const path = (typeof window !== "undefined" && window.location && window.location.pathname) || "";
          if (path.startsWith("/chat")) {
            return;
          }
          toast.success("Ticket deleted sucessfully.");
          history.push("/tickets");
        }
      });

      socket.on("contact", (data) => {
        if (data.action === "update") {
          setContact((prevState) => {
            if (prevState.id === data.contact?.id) {
              return { ...prevState, ...data.contact };
            }
            return prevState;
          });
        }
      });

    });
    return () => {
      sockets.forEach(socket => socket.disconnect());
    };
  }, [ticketId, history, urlBackendForaDoUsuario]);

  const handleDrawerOpen = () => {
    setPainelBusca(false);
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
    setPainelBusca(false);
  };

  const handleBuscar = () => {
    if (drawerOpen && painelBusca) return handleDrawerClose();
    setPainelBusca(true);
    setDrawerOpen(true);
  };

  // Busca é da conversa aberta: trocar de conversa fecha o painel dela.
  useEffect(() => {
    setIrParaMensagem(null);
    setPainelBusca((aberto) => {
      if (aberto) setDrawerOpen(false);
      return false;
    });
  }, [ticketId]);

  // ESC fecha o painel de informações do contato antes de fechar a conversa
  // (o Drawer aqui é persistente, não é Modal, então não trata ESC sozinho).
  // Ver helpers/escConversa.js.
  useEffect(() => registrarConsumidorEsc(() => {
    if (drawerOpen) {
      handleDrawerClose();
      return true;
    }
    return false;
  }), [drawerOpen]);

  const handleChange = (event) => {
    setChecked(event.target.checked);
    if (checked === false) {
      DialogFlowOn();
    }
    else if (checked === true) {
      DialogFlowOff();
    }
  };

  const handleChange2 = (event) => {
    setChecked2(event.target.checked);
    if (checked2 === false) {
      ChatBotOn();
    }
    else if (checked2 === true) {
      ChatBotOff();
    }
  };

  const handleChange3 = (event) => {
    setChecked3(event.target.checked);
    if (checked3 === false) {
      DialogFlowOnAudio();
    }
    else if (checked3 === true) {
      DialogFlowOffAudio();
    }
  };

  const formatTime = (seconds) => {
    if (!seconds || seconds < 0) return "00:00";

    seconds = Math.round(seconds);
    const days = Math.floor(seconds / 86400);
    const hours = Math.floor((seconds % 86400) / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    let formattedTime = "";

    if (days >= 1) formattedTime += `${days}d `;
    if (hours >= 1 || days >= 1) formattedTime += `${hours}h `;
    if (minutes >= 1 || hours >= 1 || days >= 1) formattedTime += `${minutes}m `;
    formattedTime += `${secs}s`;

    return formattedTime.trim();
  };

  // Flag de UI vinda do deep link do CRM: quando a instância não usa a barra de
  // digitação, a área simplesmente não existe — nesse caso não faz sentido avisar
  // bloqueio em todo ticket, então nada é renderizado (comportamento de sempre).
  const inputHabilitadoNaInstancia =
    (localStorage.getItem("icode_options") || "").includes("input");

  // Acesso à CONEXÃO — o vínculo (user.whatsapps, o mesmo do filtro da lista) ou o acesso
  // por filial, que só o backend conhece e manda em `acessoConexao`. É o portão de VER a
  // conversa: sem ele o GET /tickets/:id dá 404 e a tela cai no "conversa não encontrada".
  // Mesma conta de helpers/AcessoTicket no backend, que é o que vale.
  const temAcessoAConexao = acessoConexao || (user?.whatsapps || [])
    .some(w => mesmoNumero(w.id, ticket.whatsappId));

  // Ver é pré-requisito de responder. Depois disso:
  //   GRUPO   -> nada mais. Não tem dono nem lead pra assumir, e a aba Grupos
  //              existe justamente pro atendente da conexão.
  //   CONTATO -> dono do ticket, ou gestor — sem recorte de filial. Quem não é nem
  //              um nem outro precisa ASSUMIR o lead (é o que o aviso abaixo diz).
  // Ver #14881 (tirou a cerca de filial do contato) e #14984 (unificou as réguas).
  const ehResponsavel = temAcessoAConexao
    && (ticket.isGroup || mesmoNumero(ticket.userId, user?.id) || !!user?.gestor);

  // Nada de barra de digitação NEM de aviso enquanto o ticket desta URL não está
  // em mãos. O estado começa em {} e o fetch tem 500ms de debounce, então sem esta
  // guarda a conta acima roda sobre um ticket vazio: sem status, sem userId, sem
  // atendente — dá `ehResponsavel` false e a tela acusa "você não é o responsável"
  // por meio segundo, inclusive pro dono da conversa. Pior: se o GET /tickets/:id
  // falhar (rede, 500, sessão do iframe do CRM), o ticket NUNCA chega e a acusação
  // fica na tela até um F5 — foi o que gerou o 14881. Também cobre a troca de
  // conversa, em que o estado ainda é o ticket anterior enquanto o novo carrega.
  // Antes de 3759c21 este mesmo estado não renderizava nada; é pra lá que voltamos.
  const ticketCarregado = !loading && mesmoNumero(ticket.id, ticketId);

  // Motivo do bloqueio da barra de digitação, na ordem de prioridade: primeiro os
  // status que TÊM um botão no cabeçalho resolvendo o caso (fechado → REABRIR,
  // aguardando → ACEITAR), porque são os avisos acionáveis e os dois botões
  // aparecem pra qualquer usuário; depois falta de permissão; por último a IA.
  // A permissão não pode vir antes: ticket em "Aguardando" não tem responsável
  // (userId null), então ele caía em "você não é o responsável" com o ACEITAR
  // logo ali no cabeçalho — aviso errado e sem saída.
  // Grupo tem aviso próprio (falta de acesso à conexão, não "outro atendente") e
  // nunca fica closed/pending — ver normalizarGrupo no backend.
  // A IA tem dois avisos porque o texto manda desativá-la no cabeçalho: sem o botão
  // (usuário sem a permissão) isso seria mandar clicar em nada. "Outro atendente"
  // tem dois pela mesma razão: o texto manda assumir o lead, e quem não tem
  // renderBotaoAssumir não vê esse item no menu.
  const motivoBloqueioInput = ticket.status === "closed"
    ? "fechado"
    : ticket.status === "pending"
      ? "aguardando"
      : !ehResponsavel
        ? (ticket.isGroup
          ? "grupoSemConexao"
          : user?.renderBotaoAssumir ? "outroAtendente" : "outroAtendenteSemAssumir")
        : ticket.atendimentoIa
          ? (podeAlternarIa(user, ticket) ? "ia" : "iaSemBotao")
          : null;

  // Painel no lugar da conversa quando ela não veio. Ocupa a coluna da direita, como
  // o "Selecione uma conversa" da pages/Tickets — a lista continua do lado, então o
  // usuário sai dali clicando em outra conversa.
  if (falhaAoCarregar) {
    const naoEncontrada = falhaAoCarregar === "naoEncontrada";
    return (
      <Paper className={classes.conversaIndisponivel} elevation={0}>
        <div>
          <Typography variant="subtitle1">
            {i18n.t(naoEncontrada ? "chat.conversaNaoEncontrada" : "chat.conversaErroCarregar")}
          </Typography>
          {naoEncontrada && (
            <Typography variant="body2" className={classes.conversaIndisponivelDetalhe}>
              {i18n.t("chat.conversaNaoEncontradaDetalhe")}
            </Typography>
          )}
          {!naoEncontrada && (
            <Button
              variant="outlined"
              size="small"
              className={classes.conversaIndisponivelAcao}
              onClick={() => setTentativaCarregar((n) => n + 1)}
            >
              {i18n.t("chat.conversaTentarNovamente")}
            </Button>
          )}
        </div>
      </Paper>
    );
  }

  return (
    <div className={classes.root} id="drawer-container">
      <Paper
        variant="outlined"
        elevation={0}
        className={clsx(classes.mainWrapper, {
          [classes.mainWrapperShift]: drawerOpen,
        })}
      >
        <TicketHeader loading={loading}>
          <div className={classes.ticketInfo}>
            <TicketInfo
              contact={contact}
              ticket={ticket}
              onClick={handleDrawerOpen}
            />
          </div>

          {/* Grupo não tem SLA de atendimento (é conversa coletiva, sem lead nem
            atendente responsável), então os tempos não fazem sentido no header. */}
          {!ticket.isGroup && (
            <div className={classes.ticketStats}>
              <div className={classes.statItem}>
                <span className={classes.statLabel}>Tempo médio de resposta</span>
                <span className={classes.statValue}>
                  {formatTime(ticket.tempoResposta / ticket.qtdResposta)}
                </span>
              </div>
              <div className={classes.statItem}>
                <span className={classes.statLabel}>Tempo de espera</span>
                <span className={classes.statValue}>
                  {ticket.naoRespondido
                    ? <Timer startDate={ticket.dataUltimaMensagem} />
                    : "00:00:00"}
                </span>
              </div>
            </div>
          )}

          <div className={classes.ticketActionButtons}>
            <TicketActionButtons ticket={ticket} onBuscar={handleBuscar} buscaAberta={drawerOpen && painelBusca} />
          </div>
          {/*<Button className={classes.button} onClick={() => {DialogFlowOn();}}>DialogON</Button>
          <Button className={classes.button} onClick={() => {DialogFlowOff();}}>DialogOff</Button>
          <Button className={classes.button} onClick={() => {ChatBotOn();}}>MYSQLOn</Button>
          <Button className={classes.button} onClick={() => {ChatBotOff();}}>MYSQLOff</Button>*/}
        </TicketHeader>
        {/*<Box className={classes.box}>
        <Grid container spacing={1} style={{display:'flex', alignItems:'center', textAlign: 'center', padding:'10px'}}>
          <Grid item xs={12} md={4} sm={3}>
          <FormGroup row>
          <FormControlLabel control={
          <Switch
            checked={checked}
            onChange={handleChange}
            inputProps={{ 'aria-label': 'controlled' }}
          />}label="DialogFlow" />
          </FormGroup>
          </Grid>
          <Grid item xs={12} md={4} sm={3}>
          <FormGroup row>
          <FormControlLabel control={
          <Switch
            checked={checked3}
            onChange={handleChange3}
            inputProps={{ 'aria-label': 'controlled' }}
          />}label="DialogFlowAudio" />
          </FormGroup>
          </Grid>
          <Grid item xs={12} md={4} sm={3}>
          <FormGroup row>
          <FormControlLabel control={
          <Switch
            checked={checked2}
            onChange={handleChange2}
            inputProps={{ 'aria-label': 'controlled' }}
          />}label="MYSQL" />
          </FormGroup>
          </Grid>
        </Grid>
        </Box>*/}
        <ReplyMessageProvider>
          {isBlacklisted ? (
            <BlacklistedView
              contactId={contact?.id}
              connection={ticket?.whatsappId}
              onUnblocked={() => setIsBlacklisted(false)}
            />
          ) : (
            <>
              <MessagesList
                ticketId={ticketId}
                isGroup={ticket.isGroup}
                urlBackend={urlBackend}
                conOficial={ehCanalRestrito(ticket.whatsapp)}
                whatsappId={ticket.whatsappId}
                canal={ticket.whatsapp?.tipo}
                irParaMensagem={irParaMensagem}
              ></MessagesList>
              {inputHabilitadoNaInstancia && ticketCarregado && (
                motivoBloqueioInput ? (
                  <InputBloqueado motivo={motivoBloqueioInput} ticket={ticket} />
                ) : (
                  <MessageInput
                    ticket={ticket}
                    isGroup={ticket.isGroup}
                    tabelaPrecoId={ticket?.tabelaPrecoId ?? null}
                    setEstoqueOutrasLojas={setEstoqueOutrasLojas}
                    setModalEstoqueOutrasLojasOpen={setModalEstoqueOutrasLojasOpen}
                    ticketStatus={ticket.status} urlBackend={urlBackend} />
                )
              )}
              {/*<MessageInput ticketStatus={ticket.status} />*/}
                <ModalEstoqueOutrasLojas 
                  estoqueOutrasLojas={estoqueOutrasLojas}
                  modalEstoqueOutrasLojasOpen={modalEstoqueOutrasLojasOpen}
                  setModalEstoqueOutrasLojasOpen={setModalEstoqueOutrasLojasOpen}
                />
              </>
            )}
        </ReplyMessageProvider>
      </Paper>
      <ContactDrawer
        open={drawerOpen}
        handleDrawerClose={handleDrawerClose}
        contact={contact}
        ticket={ticket}
        loading={loading}
      >
        {painelBusca && (
          <PainelBuscaConversa
            ticketId={ticketId}
            onClose={handleDrawerClose}
            onSelecionar={(id) => setIrParaMensagem((atual) => ({ id, n: (atual?.n || 0) + 1 }))}
          />
        )}
      </ContactDrawer>
    </div>
  );
};

export default Ticket;
